import css from "../../css/listing/property-buttons.module.css";

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Router from "next/dist/client/router";
import Link from "next/link";
import dynamic from "next/dynamic";
import { useAuth } from "../common/Auth";
import isRent from "../../helper/isRent";
import Share from "./Share";
import {
    isFavorite as getIsFavorite,
    saveFavorite,
} from "../../service/favorite";

import LabelOutlineIcon from "../../static/icons/label-outline.svg";
import LabelIcon from "../../static/icons/label.svg";
import ShareIcon from "../../static/icons/share.svg";

const AuthModal = dynamic(() => import("../auth/AuthModal"), { ssr: false });

const PropertyButtons = (props) => {
    const { listing } = props;

    const { isAuthenticated } = useAuth();

    const [isFavorite, setIsFavorite] = useState(false);
    const [isShare, setIsShare] = useState(false);

    useEffect(() => {
        async function fetchData() {
            if (isAuthenticated) {
                setIsFavorite(await getIsFavorite(listing));
            }
        }

        fetchData();
    }, []);

    const handleSaveHome = async () => {
        await saveFavorite(listing);

        Router.push("/user/saved-homes");
    };

    const handleClickOnShare = () => {
        setIsShare(true);
    };

    const handleClickOnCloseShare = () => {
        setIsShare(false);
    };

    const handleShareSuccess = () => {
        setIsShare(false);
    };

    const rent = isRent(listing);

    return (
        <div className={css.buttons}>
            <button className={css.button} onClick={handleClickOnShare}>
                <ShareIcon /> Share
            </button>

            {isFavorite && (
                <Link href="/user/saved-homes" legacyBehavior>
                    <div className={css.buttonFavorited}>
                        <LabelIcon /> Saved
                    </div>
                </Link>
            )}

            {!isFavorite && isAuthenticated && (
                <button className={css.buttonFavorite} onClick={handleSaveHome}>
                    <LabelOutlineIcon /> Save
                </button>
            )}
            {!isFavorite && !isAuthenticated && (
                <AuthModal onSuccess={handleSaveHome}>
                    <button className={css.buttonFavorite}>
                        <LabelOutlineIcon /> Save
                    </button>
                </AuthModal>
            )}

            {rent && <button className={css.buttonApply}>Apply</button>}
            {!rent && <button className={css.buttonOffer}>Make Offer</button>}

            {isShare && (
                <Share
                    listing={listing}
                    onSuccess={handleShareSuccess}
                    onClose={handleClickOnCloseShare}
                />
            )}
        </div>
    );
};

PropertyButtons.propTypes = {
    listing: PropTypes.object.isRequired,
};

export default PropertyButtons;
